import { PureComponent } from 'react'
import { Modal } from '@mui/material'

import styles from './ConfirmationModal.module.scss'

export default class ConfirmationModal extends PureComponent {
  handleDeclineClick = () => {
    this.props.onConfirm(this.props.systemId, false)
  }

  handleConfirmClick = () => {
    this.props.onConfirm(this.props.systemId, true, this.props.userId)
  }

  render() {
    const {
      hideModal,
      modalTitle,
      modalText,
      highlightText = '',
      confirmLabel = 'CONFIRMAR'
    } = this.props

    return (
      <Modal
        open
        onClose={hideModal}
      >
        <div className={styles.overlay}>
          <div className={styles.modal}>
            <h2 className={styles.title}>{modalTitle}</h2>
            <p className={styles.message}>
              {modalText}
              {highlightText && (
                <>
                  {' '}
                  <strong>{highlightText}</strong>
                </>
              )}
            </p>
            <div className={styles.actions}>
              <button
                className={styles.cancelButton}
                onClick={this.handleDeclineClick}
                type='button'
              >
                CANCELAR
              </button>
              <button
                className={styles.confirmButton}
                onClick={this.handleConfirmClick}
                type='button'
              >
                {confirmLabel}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}
